import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { GetAllInterviewSubjects } from '../services/apiservice';
import Loader from '../Components/Loader';

const InterviewListing = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchSubjects = async () => {
    try {
      const subjectList = await GetAllInterviewSubjects();
      const jsonSubjectList = JSON.parse(subjectList);
      setSubjects(jsonSubjectList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching interview subjects:', error);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchSubjects();
  }, []);

  const handleSubjectClick = (subjectSlug) => {
    navigate(`/questions-answers/${subjectSlug}`);
  }

  return (
    <div>
      <Helmet>
        <title>Interview Questions by Subject - Data Beautifier</title>
        <meta name="description" content="Prepare for your interviews with our comprehensive collection of interview questions organized by subject. C#, .NET, Framework, and more." />
        <link rel="canonical" href="https://databeautifier.com/interviewlist" />
        <meta property="og:title" content="Interview Questions by Subject - Data Beautifier" />
        <meta property="og:url" content="https://databeautifier.com/interviewlist" />
      </Helmet>

      <Header />

      <div className="page-title-area">
        <div className="container">
          <div className="page-title-content">
            <h2>Interview Questions</h2>
            <ul>
              <li><a href="/">Home</a></li>
              <li className="active">Interview Questions</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="blog-area ptb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            {loading ? (
              <Loader />
            ) : subjects?.length === 0 ? (
              <div className="col-12 text-center">
                <p>No interview subjects available yet.</p>
              </div>
            ) : (
              subjects?.map((subject) => (
                <div key={subject.id} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div 
                    className="subject-card" 
                    onClick={() => handleSubjectClick(subject.slug)}
                    style={{
                      padding: '20px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      textAlign: 'center'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                      e.currentTarget.style.transform = 'translateY(-5px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = 'none';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    <h3 style={{ marginBottom: '10px' }}>{subject.name}</h3>
                    <p style={{ color: '#666', marginBottom: '0' }}>
                      {subject.questionCount || 0} Questions
                    </p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default InterviewListing;
